import React, { useEffect, useState } from "react";
import axios from "axios";
import * as fbq from "../configs/fpixel";

const BestSellers = () => {
  const [products, setProducts] = useState([]);

  function formatRupiah(angka, prefix) {
    let num = angka
        .toString()
        .replace(/[^,\d]/g, "")
        .toString(),
      split = num.split(","),
      sisa = split[0].length % 3,
      rupiah = split[0].substr(0, sisa),
      ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    // tambahkan titik jika yang di input sudah menjadi angka ribuan
    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
    return prefix == undefined ? rupiah : rupiah ? "IDR " + rupiah : "";
  }

  const getProducts = async () => {
    try {
      let baseURL = "https://api.mobile.doss.co.id/api/v1/product/";
      let data = [
        "paper-shoot-paper-camera-summer-bloom-series-peony-18mp",
        "paper-shoot-paper-camera-hand-drawing-series-red-18mp",
        "paper-shoot-paper-camera-zen-series-hanada",
        "paper-shoot-paper-camera-retro-designs-series-old-paper-shoot-18mp",
        "paper-shoot-croz-vintage-camera-set-rosewood-18mp",
        "paper-shoot-jadeite-cabbage-digital-camera-set-18mp",
        "paper-shoot-thinkkshoot-camera-set-vintage-glass-persimmon-flower-18mp",
        "paper-shoot-cork-wooden-box-camera-set-plain-18mp",
      ];

      for (let i = 0; i < data.length; i++) {
        const res = await axios.get(baseURL + data[i]);
        let isExist = products.find(
          (product) => product.id === res.data.data.id
        );
        if (!isExist) {
          setProducts((oldArray) => [...oldArray, res.data.data]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePixel = (product) => {
    fbq.event("Click product", { product });
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <section id="best-seller">
      <div className="container best-seller">
        <div className="card">
          <div className="card-body best-seller-container">
            <h2>Paling Banyak Dicari</h2>

            <div className="best-seller-list">
              {products &&
                products.map((product, index) => (
                  <div className="best-seller-card" key={index}>
                    <img
                      src={product.featured_image}
                      alt={product.name}
                      className="cursor-pointer p-3"
                      title={product.name}
                      onClick={() => {
                        window.open(
                          `https://doss.co.id/product/${product.slug}`,
                          "_blank"
                        );
                        handlePixel(product.name);
                      }}
                    />
                    <div className="best-seller-content">
                      <div>
                        <div className="product-name" title={product.name}>
                          {product.name}
                        </div>
                        <div>#{product.id}</div>
                        <div>
                          <strong>{formatRupiah(product.price, "IDR")}</strong>
                        </div>
                      </div>

                      <a
                        href={`https://doss.co.id/product/${product.slug}`}
                        target="_blank"
                        className="btn-product mt-2"
                        onClick={() => handlePixel(product.name)}
                      >
                        Lihat produk
                      </a>
                    </div>
                  </div>
                ))}
              {/* <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-011.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Paper Box Set design 1</div>
                    <div>#11955</div>
                    <div>
                      <strong>IDR 1.849.000</strong>
                    </div>
                  </div>

                  <a
                    href="https://doss.co.id/product/paper-shoot-paper-camera-summer-bloom-series-peony"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-022.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Paper Box Set design 2</div>
                    <div>#11928</div>
                    <div>
                      <strong>IDR 1.849.000</strong>
                    </div>
                  </div>
                  <a
                    href="https://doss.co.id/product/paper-shoot-paper-camera-hand-drawing-series-red"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-033.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Paper Box Set design 3</div>
                    <div>#11966</div>
                    <div>
                      <strong>IDR 1.849.000</strong>
                    </div>
                  </div>
                  <a
                    href="https://doss.co.id/product/paper-shoot-paper-camera-zen-series-hanada"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-044.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Paper Box Set design 4</div>
                    <div>#11925</div>
                    <div>
                      <strong>IDR 1.849.000</strong>
                    </div>
                  </div>
                  <a
                    href="https://doss.co.id/product/paper-shoot-paper-camera-old-lomo-camera-series-classical-white"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-055.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">CROZ Series</div>
                    <div>#11903</div>
                    <div>
                      <strong>IDR 2.549.000</strong>
                    </div>
                  </div>

                  <a
                    href="https://doss.co.id/product/paper-shoot-croz-simple-light-camera-set-rosewood"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-066.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Jadeite Cabbage</div>
                    <div>#11893</div>
                    <div>
                      <strong>IDR 5.819.000</strong>
                    </div>
                  </div>

                  <a
                    href="https://doss.co.id/product/paper-shoot-jadeite-cabbage-digital-camera-set"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-077.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">Think & Shoot series</div>
                    <div>#11914</div>
                    <div>
                      <strong>IDR 3.479.000</strong>
                    </div>
                  </div>

                  <a
                    href="https://doss.co.id/product/paper-shoot-thinkkshoot-camera-set-vintage-glass-persimmon-flower"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div>
              <div className="best-seller-card">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/best-seller-088.webp"
                  alt="img product"
                />
                <div className="best-seller-content">
                  <div>
                    <div className="product-name">
                      Cork Wooden Box Camera Set
                    </div>
                    <div>#11906</div>
                    <div>
                      <strong>IDR 2.349.000</strong>
                    </div>
                  </div>

                  <a
                    href="https://doss.co.id/product/paper-shoot-cork-wooden-box-camera-set-plain"
                    target="_blank"
                    className="btn-product mt-2"
                  >
                    Lihat produk
                  </a>
                </div>
              </div> */}
            </div>

            <div className="d-flex justify-content-center">
              <a
                href="https://doss.co.id/products?keyword=papershoot"
                target="_blank"
                className="view-btn"
              >
                Lihat lainnya
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSellers;
